// extracted by mini-css-extract-plugin
module.exports = {"description":"donation-complete_description_3MfLT","mainHeader":"donation-complete_mainHeader_1EnfN"};